import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DetailDataOrderModel } from 'src/app/models/detail-data-order.model';
import { awbHistoryModel } from 'src/app/models/awb-history.model';
import * as mapboxgl from 'mapbox-gl';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-shipping-info-gosend',
  templateUrl: './shipping-info-gosend.component.html',
  styleUrls: ['./shipping-info-gosend.component.scss'],
})
export class ShippingInfoGosendComponent implements AfterViewInit, OnChanges {
  @Input() detailOrder!: DetailDataOrderModel;
  @Input() loading: boolean = true;
  @Input() awbHistory: awbHistoryModel[] = [];
  @Output() openTrackReceipt = new EventEmitter<'nodata' | 'data'>();
  @Output() copyAwb = new EventEmitter<string>();
  @Output() trackPackage = new EventEmitter<string>();

  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;

  map: mapboxgl.Map | undefined;
  style = 'mapbox://styles/mapbox/streets-v11';
  lat: number = -6.2088;
  lng: number = 106.8456;

  ngAfterViewInit(): void {
    this.initializeMap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading'] && !changes['loading'].currentValue && !changes['loading'].firstChange) {
      setTimeout(() => {
        this.initializeMap();
      }, 100);
    }
  }

  handleType(shippingType: string): string {
    if (shippingType === 'SAPFlat') {
      return 'Flat';
    } else if (shippingType === 'JNEFlat') {
      return 'Flat';
    } else if (shippingType === 'Instant') {
      return 'Instant';
    } else {
      return '';
    }
  }

  onTrackReceipt(): void {
    if (this.awbHistory.length === 0) {
      this.openTrackReceipt.emit('nodata');
    } else {
      this.openTrackReceipt.emit('data');
    }
  }

  onCopyAwb(): void {
    this.copyAwb.emit(this.detailOrder.awb);
  }

  onTrackPackage(): void {
    this.trackPackage.emit(this.detailOrder.live_tracking_url);
  }

  splitAndConvertCoordinates(coordinateString: string): number[] {
    return coordinateString.split(',').map(coord => parseFloat(coord.trim()));
  }

  initializeMap(): void {
    if (!this.mapContainer || !this.detailOrder?.destination_pin_point) {
      return;
    }

    if (this.map) {
      this.map.remove();
      this.map = undefined;
    }

    const coordinates = this.splitAndConvertCoordinates(this.detailOrder.destination_pin_point);

    this.map = new mapboxgl.Map({
      accessToken: environment.mapbox_token,
      container: this.mapContainer.nativeElement,
      style: this.style,
      zoom: 13,
      center: [coordinates[1], coordinates[0]],
    });

    setTimeout(() => {
      this.map?.resize();
    }, 500);

    this.createMarker(this.lng, this.lat);
  }

  createMarker(lng: number, lat: number): void {
    const marker = new mapboxgl.Marker({ draggable: false })
      .setLngLat([lng, lat])
      .addTo(this.map!);

    marker.setLngLat([this.lng, this.lat]);
  }
}
